/**
 * Custom buy-options add-to-cart for Littledata / Meta / Google (Refresh theme).
 * Matches assets/product-form.js so Shopify WPM auto-emits product_added_to_cart.
 * Standard events cannot be published via Shopify.analytics.publish (returns false).
 */
window.ILCartEvents = window.ILCartEvents || {};

(function () {
  function metaFromElement(el, selectedOption) {
    if (!el) return {};
    return {
      productId: el.dataset.productId,
      productTitle: el.dataset.productTitle,
      productUrl: el.dataset.productUrl,
      vendor: el.dataset.productVendor,
      productType: el.dataset.productType,
      currencyCode: el.dataset.currency || 'USD',
      variantTitle: selectedOption && selectedOption.dataset.optionLabel,
      priceCents: selectedOption && selectedOption.dataset.priceCents,
    };
  }

  function addToCartWithTracking(options) {
    var variantId = options.variantId;
    var quantity = options.quantity || 1;
    var cartTarget = options.cartTarget;

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartTarget.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (payload.status) throw payload;
        return payload;
      });
  }

  /* Cart link: ?il_add=<variantId>:<qty>,<variantId>:<qty> adds each line, opens the slide-out
     cart, then drops the parameter so a reload does not add again. A line that cannot be added
     (unknown variant, sold out) is skipped and the rest still go in.
     Deliberately does NOT dispatch cart:updated: ild-google-ads-events.js would report one item
     at the wrong value on top of Shopify's own per-line add_to_cart (measured 2026-10-09). */
  var LINK_PARAM = 'il_add';

  function parseLinkItems(value) {
    return String(value || '')
      .split(',')
      .map(function (pair) {
        var m = /^(\d+):(\d+)$/.exec(pair.trim());
        return m && Number(m[2]) > 0 ? { variantId: m[1], quantity: Number(m[2]) } : null;
      })
      .filter(Boolean);
  }

  function openCartFor(payload) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && payload && payload.sections && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(payload);
    } else if (drawer && typeof drawer.open === 'function') {
      drawer.classList.remove('is-empty');
      drawer.open();
    }
  }

  function addCartLinkItems() {
    var api = window.ILCartEvents;
    if (api.__linkAddStarted) return; // this file is loaded twice per page (theme.liquid + cart-drawer.liquid)
    var params = new URLSearchParams(window.location.search);
    if (!params.has(LINK_PARAM)) return;
    api.__linkAddStarted = true;

    var items = parseLinkItems(params.get(LINK_PARAM));
    params.delete(LINK_PARAM);
    var query = params.toString();
    window.history.replaceState(
      null,
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );

    var cartTarget = document.querySelector('cart-drawer');
    var last = null;
    items
      .reduce(function (chain, item) {
        return chain.then(function () {
          return api
            .addToCartWithTracking({ variantId: item.variantId, quantity: item.quantity, cartTarget: cartTarget })
            .then(function (payload) {
              last = payload;
            })
            .catch(function () {}); // skip this line, keep going
        });
      }, Promise.resolve())
      .then(function () {
        if (last) openCartFor(last);
      });
  }

  window.ILCartEvents.metaFromElement = metaFromElement;
  window.ILCartEvents.addToCartWithTracking = addToCartWithTracking;

  // Start on window load, not DOMContentLoaded: measured 2026-10-09, an add that starts at
  // DOMContentLoaded beats Shopify's tracking setup and its product_added_to_cart event for the
  // first line is lost (1 of 2 recorded, 3 of 3 trials); from load both are recorded (3 of 3).
  if (document.readyState === 'complete') addCartLinkItems();
  else window.addEventListener('load', addCartLinkItems);
})();
